// Helpful? under the platform agent's finished answers and cards (D10). Wording from the Amigo design's copy sheet
// (Helpful?).
export default {
  question: 'Utile ?',
  helpful: 'Utile',
  not_helpful: 'Pas utile',
  thanks: "Merci, c'est noté.",
};
